import Loadable from 'react-loadable';
import { LoadingIndicator } from 'web-ui-kit/loading';

export default Loadable({
  loader: () => import('./CustomPieces' /* webpackChunkName: "CustomPiecesMonarch" */),
  loading: LoadingIndicator
});
